function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Logo from '../Logo';
import Button from '../Button';

var MobileHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(MobileHeader, _React$Component);

  var _super = _createSuper(MobileHeader);

  function MobileHeader() {
    _classCallCheck(this, MobileHeader);

    return _super.apply(this, arguments);
  }

  _createClass(MobileHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          logo = _this$props.logo,
          logoType = _this$props.logoType,
          content = _this$props.content,
          children = _this$props.children;
      var headerMainClasses = cx(_defineProperty({
        mobileheader: true,
        'mobileheader-skin': true
      }, "mobileheader-skin--".concat(theme), true));
      var logoColor = theme === 'dark' ? 'white' : 'green';
      var mobileStyle = {
        paddingTop: '3px'
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: headerMainClasses
      }, children && _objectSpread({}, children), /*#__PURE__*/React.createElement(Button, {
        onClick: this.toggleMenu,
        onKeydown: this.handleKeydown,
        kind: "primary",
        size: "large",
        iconName: "menu",
        icon: "left",
        className: "navdrawer__openbtn textalign-center",
        tabIndex: 0,
        ref: this.openBtn,
        includeRef: true
      }), logo ? logo() : /*#__PURE__*/React.createElement(Logo, {
        color: logoColor,
        logoType: logoType,
        height: 56
      }), content ? /*#__PURE__*/React.createElement("div", {
        style: mobileStyle,
        className: "mobileheader__search__container"
      }, content()) : null));
    }
  }]);

  return MobileHeader;
}(React.Component);

_defineProperty(MobileHeader, "propTypes", {
  children: PropTypes.node,

  /* Theme for mobile header */
  theme: PropTypes.oneOf(['dark', 'light']),
  logo: PropTypes.func,

  /** Select logo type: single, double, centered */
  logoType: PropTypes.oneOf(['single', 'double', 'centered']),
  content: PropTypes.func
});

_defineProperty(MobileHeader, "defaultProps", {
  logoType: 'double',
  theme: 'dark'
});

export { MobileHeader as default };
MobileHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MobileHeader",
  "props": {
    "logoType": {
      "defaultValue": {
        "value": "'double'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'single'",
          "computed": false
        }, {
          "value": "'double'",
          "computed": false
        }, {
          "value": "'centered'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Select logo type: single, double, centered"
    },
    "theme": {
      "defaultValue": {
        "value": "'dark'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'dark'",
          "computed": false
        }, {
          "value": "'light'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "logo": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "content": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};